import Cookies from "js-cookie";
import createDataContext from "./createDataContext";

const authReducer = (state, action) => {
  switch (action.type) {
    case "resetLoginState":
      return { ...state, loginState: action.payload };
    case "openLoginModal":
      return {
        ...state,
        loginModalOpen: true,
        loginState:
          action.payload !== undefined ? action.payload : !state.loginState,
      };
    case "closeLoginModal":
      return { ...state, loginModalOpen: false };
    case "userLoggedIn":
      return {
        ...state,
        userData: action.payload,
        loginModalOpen: false,
      };
    case "logout":
      return { ...state, userData: null, loginModalOpen: false };
    default:
      return state;
  }
};

const resetLoginState = (dispatch) => async (payload) => {
  dispatch({ type: "resetLoginState", payload });
};

const openLoginModal = (dispatch) => (payload) => {
  dispatch({ type: "openLoginModal", payload });
};

const closeLoginModal = (dispatch) => () => {
  dispatch({ type: "closeLoginModal" });
};

const userLoggedIn = (dispatch) => async (payload) => {
  dispatch({ type: "userLoggedIn", payload });

  try {
    Cookies.set("USER_TOKEN", payload.token, { expires: 90 });
    return true;
  } catch (error) {
    console.error(error, "error while loggin in.");
    return false;
  }
};

const logout = (dispatch) => async (navigate) => {
  dispatch({ type: "logout" });

  try {
    Cookies.remove("USER_TOKEN");
    return navigate("/");
  } catch (error) {
    console.error(error, "error while logout.");
    Cookies.remove("USER_TOKEN");
    return navigate("/");
  }
};

export const { Provider, Context } = createDataContext(
  authReducer,
  { resetLoginState, openLoginModal, closeLoginModal, userLoggedIn, logout },
  { loginState: true, userData: null, loginModalOpen: false },
);
